import React, { useState, useEffect } from "react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { getUsuariosSucursal } from '../../services/UsuarioSucursal';
import { getLogs } from "../../services/AuditoriaLogs";

const AuditoriaLog = () => {
  const [filtros, setFiltros] = useState({
    fechaDesde: "",
    fechaHasta: "",
    opcion: "ALL",
    accion: "ALL",
    idUsuario: "ALL",
    numeroSolicitud: "",
  });
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [resultados, setResultados] = useState([]);
  const [usuarioData, setUsuarioData] = useState([]);
  

  useEffect( () => {
    const fetchData = async () => { 
      const misUsuario = await getUsuariosSucursal();
      setUsuarioData(misUsuario);
    };
    fetchData();
  },[]);

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), (today.getMonth()) -3 , 1);
    if(Como === 'Inicio') return firstDay;
    if (Como === 'Fin') {
      // Crea una nueva fecha con la hora 23:59:59
      const endOfDay = new Date(today);
      endOfDay.setHours(23, 59, 59, 999); // 23:59:59.999
      return endOfDay;
    }
    if(Como === 'Nada') return null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros({ ...filtros, [name]: value });
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  const handleConsultar = async () => {
    // Aquí iría tu llamada a la API para traer los resultados filtrados
    const data = await getLogs(selectedDate.toISOString(),selectedDateEnd.toISOString(), filtros.opcion , filtros.accion , filtros.idUsuario, filtros.numeroSolicitud)
    setResultados(data);
  };

  const handleLimpiar = () => {
    setFiltros({
      fechaDesde: "",
      fechaHasta: "",
      opcion: "ALL",
      accion: "ALL",
      idUsuario: "ALL",
      numeroSolicitud: "",
    });
    setResultados([]);
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Título */}
      <h1 className="text-2xl font-bold mb-6 text-gray-700">Consulta de Auditoría</h1>

<div className="bg-white p-6 rounded-lg shadow-lg mt-">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
      <div className="grid grid-cols-2 md:grid-cols-8 gap-4 w-full">
                    {/* Fecha Desde */}
            <div className="col-span-2">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Desde</label>
              <SeleccionaFecha
                selectedDate={selectedDate}
                handleDateChange={handleDateChange}
              />
            </div>

            {/* Fecha Hasta */}
            <div className="col-span-2">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Hasta</label>
              <SeleccionaFecha
                selectedDate={selectedDateEnd}
                handleDateChange={handleDateChangeEnd}
              />
            </div>
        <div>
          <label className="text-xs font-semibold">Opción</label>
          <select
            className="text-xs border border-gray-300 p-2 rounded w-full"
            name="opcion"
            value={filtros.opcion}
            onChange={handleChange}
          >
            <option value="ALL">Todos</option>
            <option value="Solicitudes">Solicitudes</option>
            <option value="Asignaciones">Asignaciones</option>
            <option value="Carpetas">Carpetas</option>
          </select>
        </div>

        <div>
          <label className="text-xs font-semibold">Usuario</label>
          <select className="text-xs border border-gray-300 p-2 rounded w-full" name="idUsuario"
              value={filtros.idUsuario} onChange={handleChange}>
            <option value="ALL">Todos</option>
            {usuarioData?.map((item, index) => (
              <option  key={item._id} value={item._id}>{item.nombre}</option>
            ))}  
          </select>
        </div>
        <div>
          <label className="text-xs font-semibold">N° Solicitud</label>
          <input
            type="text"
            name="numeroSolicitud"
            value={filtros.numeroSolicitud}
            onChange={handleChange}
            placeholder="Ej. 1234"
            className="w-full border rounded p-2 text-sm"
          />
        </div>
      </div>
    </div>
    </div>

      {/* Botones */}
      <div className="flex gap-3 mb-6 mt-4">
        <button
          onClick={handleConsultar}
          className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700"
        >
          <MagnifyingGlassIcon className="w-5 h-5" />
          Consultar
        </button>
        <button
          onClick={handleLimpiar}
          className="flex items-center gap-2 bg-gray-300 text-gray-700 px-4 py-2 rounded shadow hover:bg-gray-400"
        >
          <XMarkIcon className="w-5 h-5" />
          Limpiar
        </button>
      </div>

      {/* Resultados */}
      {resultados.length > 0 ? (
        <div className="grid gap-4">
          {resultados.map((item) => (
            <div
              key={item._id}
              className="bg-white shadow rounded-lg border overflow-hidden"
            >
              {/* Header */}
              <div className="bg-gray-100 px-4 py-2 flex flex-wrap gap-4 text-sm font-medium text-gray-700">
                <span>📅 {item.fecha}</span>
                <span>📂 {item.opcion}</span>
                <span>⚡ {item.accion}</span>
                <span>👤 {item.idUsuario.nombre}</span>
                <span>📄 {item.numeroSolicitud}</span>
              </div>

              {/* Body */}
              <div className="p-4">
                <h3 className="font-semibold">{item.encabezado}</h3>
                <p className="text-sm text-gray-600">{item.detalle}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 italic">No hay resultados para mostrar.</p>
      )}
    </div>
  );
};

export default AuditoriaLog;